import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX, FiSettings, FiYoutube } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useApp } from '../context/AppContext';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { settings } = useApp();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-2' : 'bg-transparent py-4'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/0d1a77bee3ae789007ea5ef360df1d387ec1e85717a1017af2b0c3483a4e466cd39e9bbe534d979be486fb8af10a0ba5/images/aW1hZ2UvcG5n/c5ac90f76000b484186dd837b16d1cf8.png" 
              alt="Golden Compass Logo" 
              className="h-16 w-auto object-contain" 
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-brand-dark hover:text-brand-green transition-colors font-medium">Start Here</Link>
            <Link to="/about" className="text-brand-dark hover:text-brand-green transition-colors font-medium">About</Link>
            <a 
              href={settings.youtubeUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold hover:bg-red-700 transition-colors shadow-md"
            >
              <SafeIcon icon={FiYoutube} /> YouTube
            </a>
            <Link to="/admin" className="text-gray-400 hover:text-brand-gold transition-colors p-2" title="Admin Panel">
              <SafeIcon icon={FiSettings} />
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden text-brand-dark p-2" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }} 
            animate={{ opacity: 1, height: 'auto' }} 
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100 overflow-hidden"
          >
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" className="block text-brand-dark font-medium text-lg">Start Here</Link>
              <Link to="/about" className="block text-brand-dark font-medium text-lg">About Us</Link>
              <a 
                href={settings.youtubeUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-red-600 font-bold"
              >
                <SafeIcon icon={FiYoutube} /> YouTube Channel
              </a>
              <Link to="/admin" className="text-gray-500 flex items-center gap-2 pt-4 border-t border-gray-50">
                <SafeIcon icon={FiSettings} /> Admin Dashboard
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;